import { Fragment } from 'react';

const PLUS_SEPARATOR = '+';

/** Renders "+" with aria-label so screen readers announce "plus" (CEE-1160 / Figma 18062:14438). */
export function TextWithAccessiblePlus({ text }: { text: string }) {
  if (!text.includes(PLUS_SEPARATOR)) {
    return text;
  }

  const segments = text.split(PLUS_SEPARATOR);

  return (
    <>
      {segments.map((segment, index) => (
        <Fragment key={index}>
          {index > 0 ? (
            <span role="img" aria-label="plus">
              +
            </span>
          ) : null}
          {segment}
        </Fragment>
      ))}
    </>
  );
}
